<template>
  <div>
    <div v-if="!showKeypad">
      <div v-if="contact" style="width: 100%; display: flex; align-items: center; flex-direction: column;">
          <user-item :user="contact" :show-fullname="false" :show-status="false" style="width: auto" />
          <p class="text-center name">{{ contact.visiblename }}</p>
        </div>
        <p class="text-center name" v-else>{{displayName}} <br> {{ callerid }}</p>
        <p v-if="callDate">
          <chronometer :timestamp="callDate.getTime()"></chronometer>
          <!-- <the-ping :stats="stats" :janus="janus"></the-ping> -->
        </p>
        <div class="keypad">
          <hold-button class="button" :state="currentCall.hold" @hold="$emit('hold')" @unhold="$emit('unhold')" />
          <mute-button class="button" :state="currentCall.mute" @mute="$emit('mute')" @unmute="$emit('unmute')"/>
          <el-tooltip effect="dark" :content="$t('call.transfer')" placement="bottom">
            <button class="info button" @click="handleTransfer"><i
                class="fas fa-exchange-alt"></i></button>
          </el-tooltip>
          <button class="button info" @click="showKeypad = !showKeypad"><span
              class="icon-hiperme_iconos95"></span></button>
        </div>
        <hangup-button @hangup="$emit('hangup')" class="button hangup-button" />
      </div>
    <div v-if="showKeypad" class="in-call__keypad">
      <i @click="showKeypad=false" class="fas fa-arrow-left"></i>
      <the-keypad :only-numpad="true" @send-dtmf="$emit('send-dtmf', $event)" :onlyNumbers="true" class="only-numpad" v-if="showKeypad"></the-keypad>
    </div>
    
  </div>
</template>

<script>
// import ThePing from "@/components/webrtc/ThePing";
import { mapGetters } from 'vuex'
import UserItem from '@/components/common/UserItem';
import HoldButton from '@/components/softphone-widget/HoldButton'
import MuteButton from '@/components/softphone-widget/MuteButton'
import HangupButton from '@/components/softphone-widget/HangupButton'
import TheKeypad from "@/components/softphone-widget/TheKeyPad"
import Chronometer from '@/components/common/Chronometer'
export default {
  components: {
    // ThePing,
    UserItem,
    HoldButton,
    MuteButton,
    HangupButton,
    TheKeypad,
    Chronometer
  },
  props: {
    displayName: {
      required: true,
      default: null,
    },
    callerid: {
      required: true
    },
    callDate: {
      required: true
    },
    currentCall: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      stats: null,
      showKeypad: false,
      showTransfer: false
    }
  },
  computed: {
    ...mapGetters('contacts', ['getContactByCallerId']),
    contact() {
      return this.getContactByCallerId(this.callerid)
    }
  },
  methods: {
    handleTransfer() {
      this.$emit('transfer-call')
      this.showKeypad = false
    }
  }
}
</script>

<style scoped>
.in-call__keypad {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 100%;
}
.keypad {
  display: flex;
  flex-wrap: wrap;
  width: 90%;
  justify-content: space-around;
  margin: 0 auto;
}
.fa-arrow-left{
  color: var(--hiperpbx-green);
  font-size: 20px;
  cursor: pointer;
}

p {
  color: #000;
  font-weight: bold;
  text-align: center;
}

.light p,
.clasic p {
  color: var(--hiperpbx-green);
}

.hangup-button {
  margin: 0 auto;
  display: block;
}

.only-numpad:deep(.keypad) {
  width: 90%;
  margin: 0 auto;
  margin-top: var(--column)
}


.button,
.button:deep(button),
.only-numpad:deep(.keypad) button {
  height: 60px;
  width: 60px;
}

.clasic .button {
  background-color: #e1e1e1;
  color: #030303;
}

.button {
  margin-bottom: var(--column)
}
</style>